import { render } from "./ScrollMarquee.vue?vue&type=template&id=f3b58dba&scoped=true"
import script from "./ScrollMarquee.vue?vue&type=script&lang=js"
export * from "./ScrollMarquee.vue?vue&type=script&lang=js"

import "./ScrollMarquee.vue?vue&type=style&index=0&id=f3b58dba&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b58dba"]])

export default __exports__